import { getRequest } from './http-common';

const getLandlordsInfo = async (token) => {
    const URL = `profile/manager`;

    return await getRequest(URL, token);
}

export { getLandlordsInfo };
